import React, { createContext, useState } from "react";
import {Category} from "@beeldit/ecommerce/categories/models/Category";

interface CreateActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: Category;
  setElement: (element: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
}

export const CreateActionContext = createContext<CreateActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: new Category(),
  setElement: () => {},
  selectedLang: "",
  setSelectedLang: () => {},

});

interface CreateActionProviderProps {
  children: React.ReactNode;
}

export const CreateActionProvider: React.FC<CreateActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<Category>(new Category());
  const [selectedLang, setSelectedLang] = useState<string>("");

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,
    selectedLang,
    setSelectedLang,
  };
  return (
    <CreateActionContext.Provider value={value}>
      {children}
    </CreateActionContext.Provider>
  );
};
